<template>
  <div>
    <div class="text-center mb-4 mt-1 sm:hidden">
      <AhaLogo
        class="text-base-0 inline-block"
        :use-default-color="false"
        viewBox="0 0 799 183"
        width="152"
        height="26"
      />
    </div>
    <h1 class="presentation-title">
      {{ presentationName }}
    </h1>
    <p class="presentation-access-code">
      Access Code: {{ accessCode }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    presentationName: {
      type: String,
      default: 'Ask me anything',
    },
    accessCode: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.presentation-title {
  @apply text-xl text-base-0 text-center mb-2;
}

.presentation-access-code {
  @apply text-center text-base-0 text-opacity-40 text-xs;
}
</style>
